<template>
  <div>
    <div class="form-group mb-3">
     <label class="form-label">{{__('forms.PeopleRoles.responsible')}}</label>
      <select class="form-control" :name="parent_name" v-model="person_role.responsible_person_id" @change="getRoles()">
          <option v-for="person in people" :value="person.id" v-bind:key="person.id">
            {{person.surname}} {{person.name}}
          </option>
      </select>
    </div>
    <div class="form-group mb-3">
      <label class="form-label">{{__('forms.PeopleRoles.responsible_role')}}</label>
      <select class="form-control" :name="child_name" v-model="person_role.responsible_role_id">
        <option v-for="role in roles" :value="role.id" v-bind:key="role.id">
          {{role.name}}
        </option>
      </select>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
        roles: {},
    }
  },
  methods: {
    getRoles() {

      axios.get("/api/fetch-person-roles/"+this.person_role.responsible_person_id)
          .then((response) => {            
            this.roles = response.data;
          });
    }
  },
  mounted() {    
      this.getRoles();
  },
  props: {
    people: {
      type: Array,
      required: true
    },
    person_role : {
      type : Object,
      required : true
    },
    parent_name : {
      type : String,
      required : true
    },
    child_name : {
      type : String,
      required : true
    },
  }
}
</script>